import { createSelector } from "@reduxjs/toolkit";
import { activeMembersAdapter } from "@store/active-members/active-members-slice";
import { getActiveMemberKeys } from "@utils/xg-seat-utils";

/**
 * Returns all the stored active members.
 */
export const activeMembersSelector = createSelector(state => state.activeMembers, activeMembers => {
  return activeMembersAdapter.getSelectors().selectAll(activeMembers);
});

/**
 * Returns the fetching properties of the active members slice.
 */
export const fetchingActiveMembersFlagsSelector = createSelector(state => state.activeMembers, activeMembers => {
  return activeMembers.fetching;
});

/**
 * Returns whether the active members are not available yet, either because they have not been
 * requested yet or because the request is still running.
 *
 * Everything that shows active members, e.g. their table and the export of that table, has to
 * treat both cases as loading. Otherwise an action would already be offered on the empty state
 * that is held until the members arrive.
 */
export const areActiveMembersLoadingSelector = createSelector(fetchingActiveMembersFlagsSelector, ({
  status
}) => {
  return status === "pending" || status === "uninitialized";
});

/**
 * Returns the keys to look members up in the active members, see getActiveMemberKeys.
 */
export const activeMemberKeysSelector = createSelector(activeMembersSelector, activeMembers => {
  return getActiveMemberKeys(activeMembers);
});